module.exports = __webpack_public_path__ + "static/media/1.389b1493.jpg";